import { ButtonGroup } from '@chakra-ui/react';

const ModalButtons = ({
  children,
  className
}) => {
  if (!children) {
    return null;
  }
  return (
    <div className={`flex justify-end sticky bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-4 px-6 gap-4 ${className}`}>
      <ButtonGroup>
        {children}
      </ButtonGroup>
    </div>
  )
}

export {
  ModalButtons,
}